import React from 'react';
import { blueprintAvatarColor } from '../../../store/blueprints/blueprintsUtil';

interface Props {
  name: string;
  thumbnail?: string;
  /** Caller-controlled sizing/shape (width, height, borderRadius). */
  style?: React.CSSProperties;
  className?: string;
  /** Font size of the initials when no image is available. */
  fontSize?: number;
}

const base: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  flex: 'none',
};

/**
 * Renders a blueprint's thumbnail: the backend image when present, otherwise a generated
 * tile with a deterministic brand-color background and the name's first two letters.
 */
const BlueprintThumb = ({ name, thumbnail, style, className, fontSize = 16 }: Props) => {
  if (thumbnail) {
    return (
      <div className={className} style={{ ...base, background: '#f4f4f8', ...style }}>
        <img src={thumbnail} alt="" style={{ maxWidth: '100%', maxHeight: '100%' }} />
      </div>
    );
  }
  return (
    <div
      className={className}
      style={{ ...base, ...style, background: blueprintAvatarColor(name), color: '#fff', fontWeight: 700, fontSize }}
    >
      {name.slice(0, 2).toUpperCase()}
    </div>
  );
};

export default BlueprintThumb;
